export default [{
    path: '/dataList/packAge',
    component: resolve => require(['../page.vue'], resolve),
    meta: {
        title: '纸质修护',
        authLogin: true
    }
}
]